import type { FormValidator } from '@workwave-tidal/form-fairy'
import type { FormErrors, FormFields } from '../../../formFields'
import type { ValidationTexts } from '../useTexts'

const NOTES_MAX_LENGTH = 1500

export const createValidateNotes =
  (texts: ValidationTexts): FormValidator<FormFields, FormErrors> =>
  formApi => {
    const { value } = formApi.getField('notes')

    const invalidNotesError: FormErrors = {
      id: 'invalidNotesError',
      field: 'notes',
      message: texts.invalidNotes(NOTES_MAX_LENGTH),
      priority: 3,
    }

    const notes = value.status === 'exact' ? value.value : ''
    const invalid = notes.length > NOTES_MAX_LENGTH

    return {
      [invalidNotesError.id]: invalid ? invalidNotesError : null,
    }
  }
